




























































































































































































































































































































































































































































































































import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { AdcontrolProfile } from "@/models";
import WindowEvent from "@/decorators/WindowEvent";
import CompetitorsReportRecord from "@/models/interfaces/Competitors";
import EntryItem from "@/components/EntryItem.vue";
import CompetitorsFooter from "./CompetitorsFooter.vue";

class Total {
  count!: number;
  seconds!: number;
  vod!: number;
  myCount!: number;
  mySeconds!: number;
  myVod!: number;
  grp!: number;
  myGrp!: number;
  vodDevices!: boolean;
  vodSmartTv!: boolean;
  myVodDevices!: boolean;
  myVodSmartTv!: boolean;
}

@Component({ components: { EntryItem, CompetitorsFooter } })
export default class CompetitorsTable extends Vue {
  @Prop({ default: () => [] }) readonly value!: CompetitorsReportRecord[];
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ default: false }) readonly showGrp!: boolean;
  @Prop() readonly grpTargetId!: string | number;
  @Ref() inner!: HTMLDivElement;
  @Ref() table!: HTMLTableElement;
  @Getter("profile") readonly profile!: AdcontrolProfile;

  data: CompetitorsReportRecord[] = [];

  position = {
    overflow: false,
    scrolledToRight: false,
    scrolledToLeft: true,
  };

  totals: Total = Object.assign(new Total(), {
    count: 0,
    seconds: 0,
    vod: 0,
    myCount: 0,
    mySeconds: 0,
    myVod: 0,
    grp: 0,
    myGrp: 0,
    vodDevices: false,
    vodSmartTv: false,
    myVodDevices: false,
    myVodSmartTv: false,
  });

  mounted() {
    this.data = [...this.value];
    this.checkPosition();
    this.computeColumnTotals();
  }

  get hideNonVod() {
    return this.profile?.mediaSourceKind === "msk_vod";
  }

  get showVod() {
    return (
      ["msk_vod", "msk_vod_and_tv"].indexOf(
        this.profile?.mediaSourceKind ?? ""
      ) > -1
    );
  }

  get mediaSourceKind() {
    return this.profile?.mediaSourceKind;
  }

  computeColumnTotals() {
    this.totals = this.data.reduce(
      (acc, element) => {
        acc.count += element.count;
        acc.seconds += element.seconds;
        acc.vod += element.vod_presence;
        acc.myCount += element.my_count;
        acc.mySeconds += element.my_seconds;
        acc.myVod += element.my_vod_presence;
        acc.grp += parseFloat((element.grp ?? 0).toString());
        acc.myGrp += parseFloat((element.my_grp ?? 0).toString());
        acc.vodDevices = acc.vodDevices || element.vod_other_devices;
        acc.vodSmartTv = acc.vodSmartTv || element.vod_smart_tv;
        acc.myVodDevices = acc.myVodDevices || element.my_vod_other_devices;
        acc.myVodSmartTv = acc.myVodSmartTv || element.my_vod_smart_tv;
        return acc;
      },
      Object.assign(new Total(), {
        count: 0,
        seconds: 0,
        vod: 0,
        myCount: 0,
        mySeconds: 0,
        myVod: 0,
        grp: 0,
        myGrp: 0,
        vodDevices: false,
        vodSmartTv: false,
        myVodDevices: false,
        myVodSmartTv: false,
      })
    );
  }

  sortState = {
    field: "",
    direction: "",
  };

  get totalColSpan(): number {
    let cols = this.showGrp ? 3 : 2;
    if (
      ["msk_vod", "msk_vod_and_tv"].indexOf(
        this.profile?.mediaSourceKind ?? ""
      ) > -1
    ) {
      cols += 2;
    }
    if (this.profile?.mediaSourceKind === "msk_vod") {
      cols -= 3;
    }
    return cols;
  }

  get agencyColSpan(): number {
    let cols = this.showGrp ? 4 : 3;
    if (
      ["msk_vod", "msk_vod_and_tv"].indexOf(
        this.profile?.mediaSourceKind ?? ""
      ) > -1
    ) {
      cols += 2;
    }
    if (this.profile?.mediaSourceKind === "msk_vod") {
      cols -= 4;
    }
    return cols;
  }
  @Watch("value")
  onValueChanged() {
    this.sortState = {
      field: "",
      direction: "",
    };
    this.data = [...this.value];
    this.checkPosition();
    this.computeColumnTotals();
  }

  @WindowEvent("resize")
  onResize() {
    if (!this.inner) {
      return;
    }
    this.checkPosition();
  }

  onSort(field: string) {
    if (field != this.sortState.field) {
      this.sortState.field = field;
      this.sortState.direction = "asc";
    } else {
      switch (this.sortState.direction) {
        case "asc":
          this.sortState.direction = "desc";
          break;
        case "desc":
          this.sortState.direction = "";
          break;
        case "":
          this.sortState.direction = "asc";
          break;
      }
    }
    this.sort();
  }

  onRowClick(element: CompetitorsReportRecord) {
    const dateEnd = this.$route.query.date;
    const weekly = this.$route.query.weeklyData == "true";
    const dateStart = weekly
      ? this.$moment(dateEnd).subtract(6, "days").format("YYYY-MM-DD")
      : dateEnd;
    this.$router.push({
      name: "InvestorSummary",
      params: {
        type: "products",
        id: `${element.product.id}`,
      },
      query: {
        from: dateStart,
        to: dateEnd,
      },
    });
  }

  protected cfr(a: string | number, b: string | number) {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  }

  protected sort() {
    if (this.sortState.direction == "") {
      this.data = [...this.value];
    } else {
      this.data.sort((aElement, bElement) => {
        const a = this.sortState.direction == "asc" ? aElement : bElement;
        const b = this.sortState.direction == "asc" ? bElement : aElement;
        switch (this.sortState.field) {
          case "count":
            return this.cfr(a.count, b.count);
          case "seconds":
            return this.cfr(a.seconds, b.seconds);
          case "vod_presence":
            return this.cfr(a.vod_presence, b.vod_presence);
          case "my_count":
            return this.cfr(a.my_count, b.my_count);
          case "my_seconds":
            return this.cfr(a.my_seconds, b.my_seconds);
          case "my_vod_presence":
            return this.cfr(a.my_vod_presence, b.my_vod_presence);
          case "region":
            return this.cfr(a.company.region, b.company.region);
          case "company":
            return this.cfr(a.company.name, b.company.name);
          case "product":
            return this.cfr(a.product.name, b.product.name);
          case "sov":
            return this.cfr(a.sov, b.sov);
          case "grp":
            return this.cfr(
              Number.parseFloat(`${a.grp}`),
              Number.parseFloat(`${b.grp}`)
            );
          case "my_grp":
            return this.cfr(
              Number.parseFloat(`${a.my_grp}`),
              Number.parseFloat(`${b.my_grp}`)
            );
          default:
            return 0;
        }
      });
    }
  }

  protected scrollToLeft() {
    this.inner.scrollLeft = 0;
    this.checkPosition();
  }

  protected scrollToRight() {
    this.inner.scrollLeft = this.getTableWidth() - this.getElementWidth();
    this.checkPosition();
  }

  protected checkPosition() {
    this.position.overflow = this.getElementWidth() < this.getTableWidth();
    this.position.scrolledToRight =
      this.inner.scrollLeft == this.getTableWidth() - this.getElementWidth();
    this.position.scrolledToLeft = this.inner.scrollLeft == 0;
  }

  protected getElementWidth(): number {
    return this.inner?.clientWidth || 0;
  }

  protected getTableWidth(): number {
    return this.table?.clientWidth || 0;
  }
}
